
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import utils from '@/utils/utils';

export default {
name: 'booking-detail',
components: {
Popup,
Flexbox,
FlexboxItem,
},
props: {
value: {
type: Boolean,
default: false
},
startDate: String,
endDate: String,
total: {
type: Number | String,
default: 0,
},
bccDiscount: {    // BCC优惠金额
type: Number | String,
default: 0,
},
couponDiscount: { // 优惠券优惠金额
type: Number | String,
default: 0,
},
roomCount: {
type: Number | String,
default: 0,
},
currencyCode: {
type: String,
default: window.localStorage.getItem('currency_code') || 'CNY',
},
planOptions: {
type: String,
default: '',
},
priceList: {
type: Array,
default(){
return [];
},
},
},
data(){
return {
dateArr: [],
};
},
computed: {
show: {
get(){
return this.value;
},
set(val){
this.$emit('input', val);
}
},
lanType(){
return +window.localStorage.getItem('lan_type');
},
},
methods: {
onHideDetail(){
this.$emit('input', false);
},

formatPrice(value) {
return parseFloat(value).toFixed(2);
},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/BookingDetail.vue